import type { MaybeRefOrGetter } from 'vue';
import type { AiContextItem } from '#layers/ai/types/context';
import { randomUUID } from 'uncrypto';
import { onUnmounted, toValue, watch } from 'vue';
import { useChatStore } from '#layers/ai/stores/chat';

export function useAiContext(context: MaybeRefOrGetter<AiContextItem[]>) {
	const chatStore = useChatStore();
	const id = randomUUID();

	const stop = watch(
		() => toValue(context),
		(items) => {
			chatStore.setContext(id, items);
		},
		{ immediate: true },
	);

	onUnmounted(() => {
		stop();
		chatStore.removeContext(id);
	});
}
